import React from 'react';
import ContentContainer from '../content-container/content-container';

type FcWithChildren = React.FunctionComponent<React.PropsWithChildren<unknown>>;

const Content: FcWithChildren = ({ children }) => (
  <div className="sidebar-layout__content">{children}</div>
);

const Sidebar: FcWithChildren = ({ children }) => (
  <div className="sidebar-layout__sidebar">{children}</div>
);

const Top: FcWithChildren = ({ children }) => (
  <div className="sidebar-layout__top">{children}</div>
);

const SidebarLayout: FcWithChildren & {
  Content: typeof Content;
  Sidebar: typeof Sidebar;
  Top: typeof Top;
} = ({ children }) => (
  <ContentContainer className="sidebar-layout">{children}</ContentContainer>
);

SidebarLayout.Top = Top;
SidebarLayout.Content = Content;
SidebarLayout.Sidebar = Sidebar;

export default SidebarLayout;
